/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Localcms_Resources_Search_AllInputs */

const en_localcms_resources_search_all = /** @type {(inputs: Localcms_Resources_Search_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search all resources`)
};

/**
* | output |
* | --- |
* | "Search all resources" |
*
* @param {Localcms_Resources_Search_AllInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const localcms_resources_search_all = /** @type {((inputs?: Localcms_Resources_Search_AllInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Localcms_Resources_Search_AllInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_localcms_resources_search_all(inputs)
});